"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/react";

export default function SentryProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Check if Sentry is already initialized to prevent multiple initializations
    if (Sentry.getClient()) {
      console.log('✅ Sentry already initialized, skipping...');
      return;
    }

    // Only initialize Sentry on the client side
    Sentry.init({
      dsn: "https://27d038a3ca32236bc3649675de749dc2@o4507723857526784.ingest.de.sentry.io/4509586848284752",
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          // Prevent multiple replay instances
          maskAllText: false,
          blockAllMedia: false,
        }),
        // Capture unhandled exceptions and rejections
        Sentry.globalHandlersIntegration({
          onerror: true,
          onunhandledrejection: true,
        }),
      ],
      // Add debugging
      beforeSend(event) {
        console.log('🔍 Sentry captured an event:', event);
        return event;
      },
      // Add debug mode
      debug: true,
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/granu-api.d3cisive\.com/],
      // Session Replay
      replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

    console.log('✅ Sentry initialized on client side!');
    console.log('🔧 Sentry Client:', Sentry.getClient());
  }, []);

  return <>{children}</>;
} 